import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { CompensationMethod } from "../../../return";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum CompensationMethodFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

const CompensationMethodFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.COMPENSATION_METHOD,
  CompensationMethodFilterQuery,
  z.array(createEnum(CompensationMethod)),
);
export const CompensationMethodFilterSchema: z.ZodType<CompensationMethodFilter> =
  CompensationMethodFilterSchema_;
export interface CompensationMethodFilter
  extends z.infer<typeof CompensationMethodFilterSchema_> {}
